import React, { useEffect, useState } from "react";
import { PrivacyPolicydata } from "../../utils/apis/master/Master";
import parse from "html-react-parser";

const Privacy_Policy = () => {


  const [privacyPolicy, setPrivacyPolicy] = useState();
  const getPrivacyPolicyDetails = async () => {
    const res = await PrivacyPolicydata();

    if (res?.success) {
      setPrivacyPolicy(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }
  useEffect(() => {
    getPrivacyPolicyDetails()
  }, []);
  return (
    <section className="Terms_Of_Services Privacy_Policy">
      <div className="container">
        <h5 className="terms_header">Privacy Policy: Infinity Ladakh Taxi</h5>

        <div className="terms_dark_div">
          {parse(privacyPolicy?.description || "")}
        </div>
      </div>
    </section>
  );
};

export default Privacy_Policy;
